export enum ClaimDurationEnum {
  YEARS_2 = '2 years',
  YEARS_5 = '5 years',
  YEARS_10 = '10 years',
  INSURANCE_END_DATE = '67 years',
}
